import React from 'react';
import { AnimatePresence, motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import BottomModal from "../BottomModal/BottomModal";
import TapToCloseArea from "../RoomComponent/TapToCloseArea";
import BottomModalState from "../../models/BottomModalState";
import InfoSpot from "../../models/InfoSpot";
import mediumZoom from "medium-zoom";
import $events from '../../blocs/EventBloc';
import ReactDOM from "react-dom";
import RoomBloc from "../../blocs/RoomBloc";
import $ from "jquery";

export default class GalleryScreen extends React.Component {
    constructor( props ) {
        super(props);
        this.mediumZoom          = null;
        this.swiper              = null;
        this.bottomModalStackRef = React.createRef();
    }

    showDefaultGalleryContent = () => {
        this.props.roomBloc.currentState.bottomModalState = new BottomModalState(
            {
                initClosed: false,
                obj:        new InfoSpot({
                    ID:             0,
                    title:          this.props?.gallery?.gallery_title ?? '',
                    content:        this.props?.gallery?.gallery_content ?? '',
                    excerpt:        '',
                    post_type:      'infospot',
                    post_thumbnail: false
                }),
                type:       'content'
            }
        );
        this.props.roomBloc.pushState();
    };

    closeGallery = ( e ) => {
        e.preventDefault();
        this.props.museumBloc.closeGallery();
        this.props.roomBloc.closeBottomModal();
        // this.showDefaultGalleryContent();
    };

    openIndex = ( e ) => {
        e.preventDefault();
        this.props.roomBloc.currentState.bottomModalState = new BottomModalState({
            type: 'gallery_index',
            obj:  this.props.museumBloc.currentState.currentGallery
        });
        this.props.roomBloc.currentState.bottomModalState.open();
        this.props.roomBloc.pushState();
    };

    onBackgroundTap = ( e ) => {
        e.preventDefault();
        if ( !this.props.roomState.bottomModalState.isOpen ) {
            return;
        }
        if ( this.swiper !== null ) {
            this.onSlideUpdate(this.swiper);
        }
        this.props.roomBloc.closeBottomModal();
    };

    onSlideUpdate = ( swiper ) => {
        let currentIndex = swiper.realIndex - 1;
        if ( currentIndex < 0 ) {
            this.showDefaultGalleryContent();
            return;
        }

        let currentSlide                                  = this.props.gallery.gallery_images[currentIndex];
        this.props.roomBloc.currentState.bottomModalState = new BottomModalState({
            obj:  new InfoSpot({ spot: currentSlide }),
            type: 'content'
        });
        this.props.roomBloc.pushState();
    };

    componentDidUpdate( prevProps, prevState, snapshot ) {
        // if ( this.mediumZoom !== null ) {
        //     this.mediumZoom.detach();
        // }
        //
        // this.mediumZoom = mediumZoom('.gallery-screen__image img', {
        //     margin:     20,
        //     background: 'rgba(255, 255, 255, .9)'
        // });

        $events.$on('bottomModal/createNew', ( bottomModalState ) => {
            let rBloc                           = new RoomBloc();
            rBloc.currentState.bottomModalState = bottomModalState;
            rBloc.openBottomModal();
            ReactDOM.render(<BottomModal roomBloc={rBloc}
                                         tutorialState={rBloc.currentState.tutorialState}
                                         currentState={rBloc.currentState.bottomModalState}/>,
                this.bottomModalStackRef.current);
        });
    }

    componentWillUnmount() {
        $events.$off('bottomModal/createNew');
    }

    render() {
        let gallery   = this.props.gallery;
        let roomState = this.props.roomState;

        return (
            <motion.div
                variants={{
                    open:   {
                        'pointer-events': 'auto'
                    },
                    closed: {
                        'pointer-events': 'none'
                    }
                }}
                initial={'closed'}
                animate={this.props.isOpen ? 'open' : 'closed'}
                className={`gallery-screen  ${this.props.isOpen ? 'gallery-screen--open' : 'gallery-screen--closed'}  ${this.props.roomBloc.getRoomClasses(roomState)}`}>

                <motion.div variants={{
                    open:   {
                        y: 0
                    },
                    closed: {
                        y: '100%'
                    }
                }}
                            initial={'closed'}
                            exit={{ opacity: 0, transition: { duration: 0.2, delay: 0.15 } }}
                            transition={{ duration: 0.4 }}
                            animate={this.props.isOpen ? 'open' : 'closed'}
                            className="gallery-screen__bg"
                            onClick={( ev ) => this.onBackgroundTap(ev)}/>

                <motion.div
                    variants={{
                        open:   {
                            opacity:          1,
                            'pointer-events': 'auto'
                        },
                        closed: {
                            opacity:          0,
                            'pointer-events': 'none'
                        }
                    }}
                    initial={'closed'}
                    exit={{ opacity: 0, transition: { duration: 0.25, delay: 0.1 } }}
                    transition={{ duration: 0.1 }}
                    animate={this.props.isOpen ? 'open' : 'closed'}
                    className={"h--100"}>
                    <div className="swipe-screen__top-actions  gallery-screen__top-actions">
                        <div className="swipe-screen__top-action  gallery-screen__top-action  action--close"
                             onClick={( ev ) => this.closeGallery(ev)}>

                            <div className="icon">

                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.05859 18.1176C9.18441 18.1176 9.36742 18.0437 9.60761 17.8959C9.84781 17.7481 10.1109 17.5105 10.3968 17.1832C10.6141 16.9404 10.8658 16.6501 11.1517 16.3122C11.4491 15.9743 11.7465 15.6365 12.0439 15.2986C12.3413 14.9502 12.6043 14.6493 12.8331 14.3959C12.5929 14.1425 12.3127 13.8469 11.9924 13.509C11.6722 13.1712 11.3576 12.8386 11.0488 12.5113C10.7514 12.184 10.4941 11.9095 10.2767 11.6878C9.95647 11.3394 9.6934 11.0912 9.48752 10.9434C9.28163 10.7956 9.13866 10.7164 9.05859 10.7059H11.8723C11.7808 10.7164 11.7408 10.8009 11.7522 10.9593C11.7751 11.1071 11.9295 11.3499 12.2155 11.6878C12.3413 11.8356 12.5071 12.0256 12.713 12.2579C12.9189 12.4796 13.1362 12.7066 13.365 12.9389C13.5937 13.1712 13.7996 13.3823 13.9826 13.5724H14.0169C14.1771 13.3929 14.3601 13.187 14.5659 12.9547C14.7833 12.7225 14.9949 12.4902 15.2008 12.2579C15.4181 12.0256 15.5954 11.825 15.7326 11.6561C16.0071 11.3182 16.1558 11.0754 16.1787 10.9276C16.2016 10.7798 16.1673 10.7059 16.0757 10.7059H18.9409C18.8266 10.7059 18.6493 10.7798 18.4091 10.9276C18.1803 11.0648 17.9173 11.3024 17.6199 11.6403C17.414 11.8831 17.1566 12.1734 16.8478 12.5113C16.539 12.8386 16.2244 13.1712 15.9042 13.509C15.5954 13.8469 15.3151 14.1425 15.0635 14.3959C15.3151 14.6388 15.6068 14.9291 15.9385 15.267C16.2702 15.5943 16.5962 15.9268 16.9164 16.2647C17.2367 16.592 17.4998 16.8823 17.7057 17.1357C18.0145 17.4947 18.2775 17.7481 18.4949 17.8959C18.7122 18.0437 18.8609 18.1176 18.9409 18.1176H16.1272C16.2302 18.1176 16.2702 18.0437 16.2473 17.8959C16.2359 17.7481 16.0815 17.4947 15.7841 17.1357C15.6583 16.9774 15.4867 16.782 15.2694 16.5498C15.0521 16.3175 14.8233 16.0746 14.5831 15.8213C14.3543 15.5679 14.1427 15.3461 13.9483 15.1561H13.914C13.7539 15.3461 13.5651 15.5679 13.3478 15.8213C13.1305 16.0746 12.9189 16.3228 12.713 16.5656C12.5186 16.7979 12.3527 16.9985 12.2155 17.1674C11.9295 17.5053 11.7751 17.7481 11.7522 17.8959C11.7408 18.0437 11.7808 18.1176 11.8723 18.1176H9.05859Z"
                                        fill="currentColor"/>
                                    <circle cx="14" cy="14" r="13" stroke="currentColor" stroke-width="2"/>
                                </svg>

                            </div>

                            <div className="label">
                                Galerie <br/>
                                schließen
                            </div>

                        </div>

                        {( this.props.showIndex ?? true ) &&
                        <div className="swipe-screen__top-action  gallery-screen__top-action  action--index"
                             onClick={( ev ) => this.openIndex(ev)}>
                            <div className="icon">
                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM6.20508 10.1678C6.34179 10.302 6.51041 10.3691 6.71093 10.3691C6.89323 10.3691 7.05273 10.3065 7.18945 10.1812C7.32617 10.0559 7.39453 9.89485 7.39453 9.69798C7.39453 9.50112 7.32617 9.33557 7.18945 9.20134C7.05273 9.06711 6.89323 9 6.71094 9C6.52865 9 6.36458 9.06711 6.21875 9.20134C6.07292 9.33557 6 9.50112 6 9.69798C6 9.87696 6.06836 10.0336 6.20508 10.1678ZM8.84375 10.0067C8.93489 10.0872 9.04427 10.1275 9.17187 10.1275H16.7734C17.0651 10.1275 17.2109 9.98434 17.2109 9.69798C17.2109 9.57271 17.1699 9.46532 17.0879 9.37584C17.0059 9.28635 16.901 9.24161 16.7734 9.24161H9.17187C9.04427 9.24161 8.93489 9.28635 8.84375 9.37584C8.7526 9.46532 8.70703 9.57271 8.70703 9.69798C8.70703 9.82326 8.7526 9.92617 8.84375 10.0067ZM7.59961 13.4832C7.73632 13.6264 7.90494 13.698 8.10546 13.698C8.28776 13.698 8.44726 13.6309 8.58398 13.4966C8.7207 13.3624 8.78906 13.1969 8.78906 13C8.78906 12.8031 8.7207 12.6376 8.58398 12.5034C8.44726 12.3691 8.28776 12.302 8.10546 12.302C7.90494 12.302 7.73633 12.3736 7.59961 12.5168C7.46289 12.66 7.39453 12.821 7.39453 13C7.39453 13.179 7.46289 13.34 7.59961 13.4832ZM10.2383 13.3087C10.3294 13.3893 10.4388 13.4295 10.5664 13.4295H18.168C18.4596 13.4295 18.6055 13.2864 18.6055 13C18.6055 12.7136 18.4596 12.5705 18.168 12.5705H10.5664C10.4388 12.5705 10.3294 12.6107 10.2383 12.6913C10.1471 12.7718 10.1016 12.8747 10.1016 13C10.1016 13.1253 10.1471 13.2282 10.2383 13.3087ZM8.99414 16.7987C9.13085 16.9329 9.29036 17 9.47265 17C9.67317 17 9.84179 16.9329 9.97851 16.7987C10.1152 16.6644 10.1836 16.4989 10.1836 16.302C10.1836 16.123 10.1152 15.9664 9.97851 15.8322C9.84179 15.698 9.67317 15.6309 9.47265 15.6309C9.27213 15.6309 9.10807 15.6935 8.98046 15.8188C8.85286 15.9441 8.78906 16.1051 8.78906 16.302C8.78906 16.4989 8.85742 16.6644 8.99414 16.7987ZM11.6328 16.6107C11.724 16.6913 11.8333 16.7315 11.9609 16.7315H19.5625C19.8542 16.7315 20 16.5884 20 16.302C20 16.0157 19.8542 15.8725 19.5625 15.8725H11.9609C11.8333 15.8725 11.724 15.9128 11.6328 15.9933C11.5417 16.0738 11.4961 16.1767 11.4961 16.302C11.4961 16.4273 11.5417 16.5302 11.6328 16.6107Z"
                                          fill="currentColor"/>
                                </svg>

                            </div>
                        </div>
                        }
                    </div>

                    <TapToCloseArea/>

                    <div className="gallery-screen__image-container">
                        {( ( gallery?.gallery_images?.length ?? 0 ) > 0 ) &&
                        <Swiper
                            navigation={{
                                prevEl: '.prev',
                                nextEl: '.next'
                            }}
                            pagination={{
                                "el":             '.swiper-pagination',
                                "dynamicBullets": true
                            }}
                            slideToClickedSlide={true}
                            spaceBetween={10}
                            slidesPerView={'auto'}
                            centeredSlides={true}
                            onSlideChange={( swiper ) => this.onSlideUpdate(swiper)}
                            onSwiper={( swiper ) => {
                                this.swiper = swiper;
                                this.showDefaultGalleryContent();
                            }}>

                            <SwiperSlide className="gallery-screen__image">
                                <motion.div layoutId={`gallery-thumb-${gallery.gallery_title}`}>
                                    <img src={gallery.gallery_thumbnail?.sizes?.medium ?? ''} data-zoom-src={gallery.gallery_thumbnail?.url} alt={gallery.gallery_title}/>
                                </motion.div>
                            </SwiperSlide>

                            {gallery?.gallery_images?.map(( image, i ) => {
                                console.log(image.post_thumbnail);
                                return <SwiperSlide className="gallery-screen__image  [ wow fadeInUp ]" data-wow-duration=".45s">
                                    <img src={image.post_thumbnail?.sizes?.medium?.url ?? ''} data-zoom-src={image.post_thumbnail?.sizes?.original?.url} alt={image.post_title}/>
                                </SwiperSlide>}
                            )}

                            <div slot="container-end" className="swiper-container-horizontal">
                                <div className="swiper-arrow  arrow-prev  prev"/>
                                <div className="swiper-pagination"/>
                                <div className="swiper-arrow  arrow-next next"/>
                            </div>
                        </Swiper>}
                    </div>

                    {( typeof roomState?.bottomModalState !== "undefined" ) &&
                    <BottomModal ref="bottomModal"
                                 currentState={roomState?.bottomModalState}
                                 tutorialState={roomState?.tutorialState}
                                 roomBloc={this.props.roomBloc}>
                    </BottomModal>}

                    <div slot="bottom-modal-stack" ref={this.bottomModalStackRef}/>
                </motion.div>
            </motion.div>
        );
    }

}
